import React from 'react';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import PopupResult, { EResultPopupStatus } from '@r1-frontend/ui-react/components/popups/popupResult';

type TNotAvailableTimePopupProps = {
    isOpen: boolean,
    handleClosePopup: () => void,
    title?: string,
    buttonText?: string,
}

const NotAvailableTimePopup = ({ isOpen, handleClosePopup, title, buttonText }: TNotAvailableTimePopupProps): JSX.Element => {
    return (
        <PopupResult
            isOpen={isOpen}
            onClose={handleClosePopup}
            title={title ?? 'Это время уже занято. Пожалуйста, выберите время для визита инженера ещё раз.'}
            type={EResultPopupStatus.ERROR}
        >
            <Button bType={'action'} onClick={handleClosePopup}>{buttonText ?? 'Выбрать другое время'}</Button>
        </PopupResult>
    );
};

export default NotAvailableTimePopup;
